<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../assets/loader.gif" />
    </vue-element-loading>
    <div class="animated fadeIn">
      <b-row v-if="analytics">
        <b-col cols="12" sm="6" lg="3">
          <b-card :no-body="true" footer-class="px-3 py-2">
            <b-card-body class="p-3 clearfix">
              <i class="fa fa-cogs bg-primary p-3 font-2xl mr-3 float-left"></i>
              <div class="h5 text-primary mb-0 mt-2">{{analytics.incidentcount}}</div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">TOTAL INCIDENTS</div>
            </b-card-body>
            <div slot="footer">
              <router-link to="/Incidents" class="font-weight-bold font-xs btn-block text-muted">
                View Details
                <i class="fa fa-angle-right float-right font-lg"></i>
              </router-link>
            </div>
          </b-card>
        </b-col>
        <b-col cols="12" sm="6" lg="3">
          <b-card :no-body="true" footer-class="px-3 py-2">
            <b-card-body class="p-3 clearfix">
              <i class="fa fa-laptop bg-info p-3 font-2xl mr-3 float-left"></i>
              <div class="h5 text-info mb-0 mt-2">{{analytics.beencutcount}}</div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">TRESS BEEN CUT</div>
            </b-card-body>
            <div slot="footer">
              <router-link to="/Incidents" class="font-weight-bold font-xs btn-block text-muted">
                View Details
                <i class="fa fa-angle-right float-right font-lg"></i>
              </router-link>
            </div>
          </b-card>
        </b-col>
        <b-col cols="12" sm="6" lg="3">
          <b-card :no-body="true" footer-class="px-3 py-2">
            <b-card-body class="p-3 clearfix">
              <i class="fa fa-moon-o bg-warning p-3 font-2xl mr-3 float-left"></i>
              <div class="h5 text-warning mb-0 mt-2">{{analytics.havebeencutcount}}</div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">TREES HAVE BEEN CUT</div>
            </b-card-body>
            <div slot="footer">
              <router-link to="/Incidents" class="font-weight-bold font-xs btn-block text-muted">
                View Details
                <i class="fa fa-angle-right float-right font-lg"></i>
              </router-link>
            </div>
          </b-card>
        </b-col>
        <b-col cols="12" sm="6" lg="3">
          <b-card :no-body="true" footer-class="px-3 py-2">
            <b-card-body class="p-3 clearfix">
              <i class="fa fa-bell bg-danger p-3 font-2xl mr-3 float-left"></i>
              <div class="h5 text-danger mb-0 mt-2">{{analytics.mightbecutcount}}</div>
              <div class="text-muted text-uppercase font-weight-bold font-xs">TREES MIGHT BE CUT</div>
            </b-card-body>
            <div slot="footer">
              <router-link to="/Incidents" class="font-weight-bold font-xs btn-block text-muted">
                View Details
                <i class="fa fa-angle-right float-right font-lg"></i>
              </router-link>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <b-card v-if="analytics">
        <b-row>
          <b-col cols="6" md="6">
            <h4 id="traffic" class="card-title mb-0">Traffic</h4>
            <div class="small text-muted">{{chartName}}</div>
          </b-col>
          <b-col cols="6" md="6" class="ml-auto text-right">
            <b-dropdown variant="outline-primary" size="sm" id="dropdown-1" :text="chartName">
              <b-dropdown-item
                v-for="(item,i) in chartTypes"
                :key="i"
                @click="updateChart(item)"
              >{{item.name}}</b-dropdown-item>
            </b-dropdown>
          </b-col>
        </b-row>
        <!-- Chart -->
        <b-row>
          <b-col>
            <main-chart-example
              chartId="main-chart-01"
              class="chart-wrapper"
              style="height:300px;margin-top:40px;"
              height="300"
              :type="chartType"
              :chartData="analytics.graph"
            ></main-chart-example>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col sm="5">
            <h4 id="traffic" class="card-title mb-0">Traffic</h4>
            <div class="small text-muted">This Month</div>
          </b-col>
        </b-row>
        <div slot="footer">
          <b-row class="text-center">
            <b-col class="mb-sm-2 mb-0">
              <div class="text-muted">Incidents</div>
              <strong>{{analytics.thismonth_incidentcount}}</strong>
              <b-progress
                height="{}"
                class="progress-xs mt-2"
                :precision="1"
                variant="success"
                :value="100"
              ></b-progress>
            </b-col>
            <b-col class="mb-sm-2 mb-0 d-md-down-none">
              <div class="text-muted">Trees Been Cut</div>
              <strong>{{analytics.thismonth_beencutcount}}</strong>
              <b-progress
                height="{}"
                class="progress-xs mt-2"
                :precision="1"
                variant="info"
                :value="100"
              ></b-progress>
            </b-col>
            <b-col class="mb-sm-2 mb-0">
              <div class="text-muted">Trees Have Been Cut</div>
              <strong>{{analytics.thismonth_havebeencutcount}}</strong>
              <b-progress
                height="{}"
                class="progress-xs mt-2"
                :precision="1"
                variant="warning"
                :value="100"
              ></b-progress>
            </b-col>
            <b-col class="mb-sm-2 mb-0">
              <div class="text-muted">Trees Might Be Cut</div>
              <strong>{{analytics.thismonth_mightbecutcount}}</strong>
              <b-progress
                height="{}"
                class="progress-xs mt-2"
                :precision="1"
                variant="danger"
                :value="100"
              ></b-progress>
            </b-col>
            <b-col class="mb-sm-2 mb-0 d-md-down-none">
              <div class="text-muted">New Users</div>
              <strong>{{analytics.thismonth_usercount}}</strong>
              <b-progress height="{}" class="progress-xs mt-2" :precision="1" :value="100"></b-progress>
            </b-col>
          </b-row>
        </div>
      </b-card>
      <b-row v-if="analytics">
        <b-col md="12">
          <b-card header="Last 10 Incidents">
            <br />
            <b-table
              :hover="true"
              :striped="true"
              :bordered="false"
              :small="false"
              :fixed="false"
              class="mb-0 table-outline"
              responsive="sm"
              :items="analytics.lastten"
              :fields="tableFields"
              head-variant="light"
              @row-clicked="rowClicked"
            >
              <template slot="beencut" slot-scope="data">
                <div class="text-center">
                  <span v-if="data.item.beencut">{{data.item.beencut}}</span>
                  <span v-else>-</span>
                </div>
              </template>
              <template slot="caseid" slot-scope="data">
                <div class="text-center">
                  <span v-if="data.item.caseid">{{data.item.caseid}}</span>
                  <span v-else>-</span>
                </div>
              </template>
              <template slot="createddate" slot-scope="data">
                <div class="text-left">
                  <span v-if="data.item.createddate">{{formatDate(data.item.createddate)}}</span>
                  <span v-else>-</span>
                </div>
              </template>
              <template slot="havebeencut" slot-scope="data">
                <div class="text-center">
                  <span v-if="data.item.havebeencut">{{data.item.havebeencut}}</span>
                  <span v-else>-</span>
                </div>
              </template>
              <template slot="locationname" slot-scope="data">
                <div class="text-left">
                  <span v-if="data.item.locationname">{{data.item.locationname}}</span>
                  <span v-else>-</span>
                </div>
              </template>
              <template slot="mightbecut" slot-scope="data">
                <div class="text-center">
                  <span v-if="data.item.mightbecut">{{data.item.mightbecut}}</span>
                  <span v-else>-</span>
                </div>
              </template>
              <template slot="addedby" slot-scope="data">
                <div class="text-left">
                  <span v-if="data.item.addedby.name">{{data.item.addedby.name}}</span>
                  <span v-else>-</span>
                </div>
              </template>
            </b-table>
            <template slot="footer">
              <router-link to="/Incidents">
                <b-button size="sm">View More</b-button>
              </router-link>
            </template>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import MainChartExample from "./MainChartExample";

export default {
  components: {
    MainChartExample
  },
  data() {
    return {
      chartName: "Last Year",
      chartTypes: [
        { name: "Last Year", value: 12 },
        { name: "Last 6 Months", value: 6 },
        { name: "Last 4 Months", value: 4 },
        { name: "Last 3 Months", value: 3 }
      ],
      chartType: 12,
      tableFields: [
        { key: "caseid", label: "Case ID", sortable: false },
        { key: "createddate", label: "Created On", sortable: false },
        { key: "beencut", label: "Been Cut", sortable: false },
        { key: "mightbecut", label: "Might be cut", sortable: false },
        { key: "havebeencut", label: "Have Been Cut", sortable: false },
        { key: "locationname", label: "Location", sortable: false },
        { key: "addedby", label: "Added By", sortable: false }
      ],
      analytics: null,
      appLoading: false,
      ServerError: false
    };
  },
  mounted() {
    // this.getData();
  },
  methods: {
    updateChart(item) {
      this.chartName = item.name;
      this.chartType = item.value;
    },
    getData() {
      this.appLoading = true;
      axios({
        url: "/dashboard/admin",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        }
      })
        .then(response => {
          this.analytics = response.data.data;
          this.appLoading = false;
        })
        .catch(e => {
          this.ServerError = true;
        });
    },

    rowClicked(item) {
      this.$router.push("/Incidents/" + item._id);
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year +
        " " +
        hours +
        ":" +
        minutes +
        " " +
        ampm;
      return strTime;
    }
  }
};
</script>
<style>
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
</style>
